export const paths = {
  login: "/",
  call: "/call",
  audioSettings: "/audio-settings",
};
